import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=c3e72588&scoped=true&"
import script from "./Interview.vue?vue&type=script&lang=js&"
export * from "./Interview.vue?vue&type=script&lang=js&"
import style0 from "./Interview.vue?vue&type=style&index=0&id=c3e72588&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e72588",
  null
  
)

export default component.exports